/**
 * Where this module's requests go.
 *
 * Every Machine call is written against `/api/machine/...` upstream — the path
 * the cockpit API has always served. `BASE` is the PORTAL prefix in front of it,
 * routed by `functions/meteoric-machine/[[path]].ts` to whatever origin serves
 * that API today.
 *
 * The prefix exists so the module holds no hostname. Machine's API is served by
 * Meteoric right now; when it moves, that is one Cloudflare variable and not one
 * line in this module.
 */
export const BASE = import.meta.env.VITE_MACHINE_API_BASE ?? "/meteoric-machine";

/** The upstream path for one Machine route, e.g. `path("/state/stats")`. */
export function path(suffix: string): string {
  return `${BASE}/api/machine${suffix}`;
}
